import FullCalendar from '@fullcalendar/react';
import esLocale from '@fullcalendar/core/locales/es';
import { MonitoreoService } from '../../service/monitoreo/MonitoreoService';
import { useEffect, useRef, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputComponent } from '../../components/InputComponent';
import { NivelPerfil } from '../../models/monitoreo/NivelPerfil';
import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { TablaRiesgos } from './TablaRiesgos';
import { Tooltip } from 'primereact/tooltip';
import '../../components/estilo.css';
import { confirmDialog } from 'primereact/confirmdialog';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Calendar } from 'primereact/calendar';
import { ConfirmDialogPersonalizado } from '../../components/ConfirmDialogPersonalizado';
import { useToken } from '../../components/useToken';
import { Generico } from "../../components/Generico";
import { Divider } from 'primereact/divider';
import { InputSwitch } from 'primereact/inputswitch';
import { TablaDinamica } from '../../components/TablaDinamica';
import { Column } from 'primereact/column';
import { MatrizRiesgoCandidata } from '../../models/monitoreo/MatrizRiesgoCandidata';
import { useLazyParams } from '../../hooks/useLazyParams';
import { TablaDetalleCandidata } from './TablaDetalleCandidata';

export const RiesgoPerfilCalendario = ({ permss, funcionalidades, toast, generic, plugins, initialView, justificaciones, procedimientosControl, nivelesRiesgo, nivelesAlerta }) => {

    const monitoreoService = new MonitoreoService();
    const omodel = new NivelPerfil();
    const defaultValues = generic.default(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue } = useForm({ defaultValues });
    const [dialogMonitoreo, setDialogMonitoreo] = useState(false);
    const [matriz, setMatriz] = useState(null);
    const [dialogMatriz, setDialogMatriz] = useState(false);
    const [rangoFecha, setRangoFecha] = useState({ inicio: null, fin: null });
    const [rangoVista, setRangoVista] = useState({ start: null, end: null });
    const [mes, setMes] = useState(null);
    const [registers, setRegisters] = useState(null);
    const calendarRef = useRef(null);
    const { inText, inNumber } = InputComponent({ omodel, generic, errors, control, permss, id: getValues('id') });
    const tooltipRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [rangoManual, setRangoManual] = useState(null);
    const [dialogSeleccionManual, setDialogSeleccionManual] = useState(false);
    const [editarApetitos, setEditarApetitos] = useState(false);
    const { getRol } = useToken();
    const { getContrastTextColor } = Generico();
    const { minDate, maxDate } = useMemo(() => {
        const today = new Date();
        const minDate = null;
        const maxDate = today;
        return { minDate, maxDate };
    }, []);
    const [guardando, setGuardando] = useState(false);
    const [matrizSeleccionada, setMatrizSeleccionada] = useState(null);
    const [dialogMigracion, setDialogMigracion] = useState(false);
    const [expandedRows, setExpandedRows] = useState(null);
    const MatricesCandidatasModel = useMemo(() => new MatrizRiesgoCandidata().model, []);
    const tablaEstadoMatrices = useLazyParams({ modelo: MatricesCandidatasModel, initialRows: 5 });

    const handleDateSelect = (selectInfo) => {
        const { startStr, start, end } = selectInfo;

        // Ajustar la fecha fin (restar 1 día porque FullCalendar da el end excluyente)
        const endDate = new Date(end);
        endDate.setDate(endDate.getDate() - 1);
        const endInclusiveStr = endDate.toISOString().slice(0, 10);

        // Guardamos las fechas seleccionadas como inclusivas
        setRangoFecha({ inicio: startStr.slice(0, 10), fin: endInclusiveStr });

        const tipoFecha = "TIP_RAN_FEC_MATRIZ_RANGO";

        const nombreMes = start.toLocaleString('default', { month: 'long' });
        setMes(nombreMes.charAt(0).toUpperCase() + nombreMes.slice(1));

        const { dialogMessage } = mensajesRiesgo(start, endDate);

        confirmDialog({
            group: 'confirmar-fecha', // abre el dialog del mismo grupo
            header: 'Confirmación',
            message: {
                texto: dialogMessage,
                tipoFecha: tipoFecha
            },
            style: { width: '30vw', borderRadius: '1rem' }
        });
    };

    const mensajesRiesgo = (startDate, endDate) => {
        const FORMAT_OPTIONS = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
        const MS_PER_DAY = 1000 * 60 * 60 * 24;

        const fechaInicio = startDate.toLocaleDateString('es-ES', FORMAT_OPTIONS).replace(',', '');
        const fechaFin = endDate.toLocaleDateString('es-ES', FORMAT_OPTIONS).replace(',', '');

        const days = Math.round((endDate - startDate) / MS_PER_DAY);

        if (days === 0) {
            return {
                dialogMessage: `¿Está seguro de generar el nivel de riesgo para el ${fechaInicio}?`,
                toastMessage: `Nivel de riesgo para el ${fechaInicio} generado con éxito.`
            };
        } else {
            return {
                dialogMessage: `¿Está seguro de generar el nivel de riesgo desde el ${fechaInicio}, hasta el ${fechaFin}?`,
                toastMessage: `Nivel de riesgo desde ${fechaInicio} hasta ${fechaFin} generado con éxito.`
            };
        }
    };

    // Funcion que trae la información, similar a loadLazyData
    const handleDatesSet = (dateInfo, forzarRecarga = false) => {
        const { startStr, endStr } = dateInfo;
        const start = startStr.slice(0, 10);
        const end = endStr.slice(0, 10);

        if (forzarRecarga || (start !== rangoVista.start || end !== rangoVista.end)) {
            setRangoVista({ start, end });
            setRegisters([]);
            setLoading(true);
            const payload = { fechaInicio: start, fechaFin: end, rol: getRol(), };
            monitoreoService.consultarInfo('monitoreo/nivel-riesgo-perfil/matriz', { lazyEvent: JSON.stringify(payload) }).then((res) => {
                const baseColors = getBaseColors(nivelesRiesgo, nivelesAlerta);
                const eventosAjustados = res.data.map((evento, index) => {
                    const endDate = new Date(evento.end);
                    endDate.setDate(endDate.getDate() + 1);
                    const color = baseColors[index % baseColors.length]; // const color = baseBlueColors[index % baseBlueColors.length]; // Si se quiere azules
                    const colorTexto = getContrastTextColor(color);
                    return { ...evento, end: endDate.toISOString().slice(0, 10), backgroundColor: color, borderColor: color, textColor: colorTexto };
                });
                setRegisters(eventosAjustados);
            }).catch((error) => {
                generic.funcErrorHibrida(error, toast, setError);
            }).finally(() => {
                setLoading(false);
            });
        }
    };

    useEffect(() => {
        if (getValues('id') == null && getValues('matriz_origen_id')) {
            setValue('matriz_origen_id', null);
            setMatrizSeleccionada(null);
            toast.current?.show({ severity: 'info', summary: 'Fechas modificadas', detail: 'Se deseleccionó la matriz de migración debido al cambio de fechas.' });
        }
        // eslint-disable-next-line
    }, [rangoFecha]);

    const buscarMatricesOrigen = () => {
        if (!rangoFecha.inicio || !rangoFecha.fin) {
            toast.current.show({ severity: 'warn', summary: 'Fechas requeridas', detail: 'Debe seleccionar un rango de fechas en el calendario primero.' });
            return;
        }
        setDialogMigracion(true);
    };

    const seleccionarMatrizOrigen = (rowData) => {
        setValue('matriz_origen_id', rowData.id);
        setMatrizSeleccionada(rowData);
        toast.current.show({
            severity: 'success',
            summary: 'Matriz vinculada',
            detail: `Se migrará información de: ${rowData.nombre}`
        });
        setDialogMigracion(false);
    };

    const cuerpoTemplates = {
        accionesBody: (rowData) => (
            <div className="flex justify-content-center">
                <Button type="button" icon="pi pi-check-circle" label="Elegir para migrar" className="p-button-sm p-button-outlined"
                    onClick={() => seleccionarMatrizOrigen(rowData)} />
            </div>
        ),
    };

    const rowExpansionTemplate = (rowData) => {
        return (
            <TablaDetalleCandidata matriz={rowData} monitoreoSrv={monitoreoService} generic={generic} toast={toast}
                setError={setError} getRol={getRol} fechaInicio={rangoFecha.inicio} fechaFin={rangoFecha.fin} />
        );
    };

    const loadMatricesCandidatas = () => {
        if (!rangoFecha.inicio || !rangoFecha.fin) return;
        tablaEstadoMatrices.setLoading(true);
        let _lazyParams = { ...tablaEstadoMatrices.lazyParams };
        if (getRol()) { _lazyParams.rol = getRol(); }

        const payload = {
            lazyEvent: JSON.stringify(_lazyParams),
            fecha_inicio: rangoFecha.inicio,
            fecha_fin: rangoFecha.fin
        };

        monitoreoService.consultarInfo('monitoreo/nivel-riesgo-perfil/listar-candidatas-migracion', payload).then(res => {
            tablaEstadoMatrices.setData(res.data.registros);
            tablaEstadoMatrices.setTotalRecords(res.data.total);
        }).catch(error => {
            generic.funcErrorHibrida(error, toast, setError);
        }).finally(() => {
            tablaEstadoMatrices.setLoading(false);
        });
    };

    useEffect(() => {
        if (dialogMigracion) {
            loadMatricesCandidatas();
        }
        // eslint-disable-next-line
    }, [tablaEstadoMatrices.lazyParams, dialogMigracion]);

    const mostrarMatriz = (data) => {
        tooltipRef.current?.hide();
        // Se toman los valores con el cual fue inicializado el evento del fullCalendar
        // Aquí se deben colocar los valores que necesita tabla matriz para mostrarlos
        const endDate = data.event.endStr ? new Date(new Date(data.event.endStr).getTime() - 86400000) : null;
        const matrizSeleccionada = {
            id: data.event.id,
            nombre: data.event.extendedProps.nombre,
            detalle: data.event.extendedProps.detalle,
            codigo: data.event.title, // El codigo se le pasa como título al evento
            fecha_inicio: data.event.startStr.slice(0, 10),
            fecha_fin: endDate ? endDate.toISOString().slice(0, 10) : null,
            apetito_inherente: data.event.extendedProps.apetito_inherente,
            tolerancia_inherente: data.event.extendedProps.tolerancia_inherente,
            apetito_residual: data.event.extendedProps.apetito_residual,
            tolerancia_residual: data.event.extendedProps.tolerancia_residual,
        };
        setMatriz(matrizSeleccionada);
        setDialogMonitoreo(true);
    }

    const onSubmit = (data) => {
        if (editarApetitos) {
            let hayError = false;
            ['apetito_inherente', 'tolerancia_inherente', 'apetito_residual', 'tolerancia_residual'].forEach(field => {
                if (data[field] > 5) { setError(field, { type: 'manual', message: 'El valor máximo permitido es 5' }); hayError = true; }
            });
            // Alerta Apetito > Tolerancia
            if (data.apetito_inherente > data.tolerancia_inherente) {
                setError('apetito_inherente', { type: 'manual', message: 'El apetito debe ser menor o igual a la tolerancia' }); hayError = true;
            }
            if (data.apetito_residual > data.tolerancia_residual) {
                setError('apetito_residual', { type: 'manual', message: 'El apetito debe ser menor o igual la tolerancia' }); hayError = true;
            }
            if (hayError) return;
        } else { delete data.apetito_inherente; delete data.tolerancia_inherente; delete data.apetito_residual; delete data.tolerancia_residual; }
        data.tipo_rango_fecha = 'TIP_RAN_FEC_MATRIZ_DIA';
        data.fecha_inicio = rangoFecha.inicio;
        data.fecha_fin = rangoFecha.fin;
        setGuardando(true);
        if (getValues('id') == null) {
            monitoreoService.nuevo(data, 'monitoreo/nivel-riesgo-perfil/nuevo').then(res => {
                generic.funcSuccess(res, toast);
                setDialogMatriz(false);
                setMatriz(res.data);
                setDialogMonitoreo(true);
            }).catch(error => {
                generic.funcErrorHibrida(error, toast, setError);
            }).finally(() => {
                setGuardando(false);
            });
        } else {
            monitoreoService.editar(data, 'monitoreo/nivel-riesgo-perfil/editar').then(res => {
                generic.funcSuccess(res, toast);
                setDialogMatriz(false);
                reset();
            }).catch(error => {
                generic.funcErrorHibrida(error, toast, setError);
            }).finally(() => {
                setGuardando(false);
            });
        }
    }

    const formatearFechaUTC = fecha => fecha.toISOString().slice(0, 10);

    const onAceptarRango = () => {
        if (!(rangoManual?.[0] && rangoManual?.[1])) return;
        const [start, end] = rangoManual;
        const endPlusOne = new Date(end.getTime() + 24 * 60 * 60 * 1000);
        const startStr = formatearFechaUTC(start);
        const endStrPlus = formatearFechaUTC(endPlusOne);
        handleDateSelect({ start, end: endPlusOne, startStr, endStr: endStrPlus });
        setRangoManual([null, null]);
    };

    const getBaseColors = (nivelesRiesgo, nivelesAlerta) => {
        const riesgo = nivelesRiesgo.map(n => `#${n.color_bg}`);
        const alerta = nivelesAlerta.map(n => `#${n.color_bg}`);
        return [...alerta, ...riesgo];
    };

    return (
        <>
            <Tooltip ref={tooltipRef} target=".tooltip-calendario" appendTo={document.body} position="bottom"
                style={{ zIndex: 9999, maxWidth: '300px', padding: '1rem', animation: 'fadeIn 0.3s ease-in-out' }}
            />
            <ConfirmDialogPersonalizado group="confirmar-fecha" icon="pi pi-calendar" acceptLabel="Confirmar" rejectLabel="Cancelar" onAccept={() => setDialogMatriz(true)} />
            {!dialogMonitoreo &&
                <div style={{ position: 'relative', minHeight: '500px' }}>
                    {loading && (
                        <div style={{ position: 'absolute', zIndex: 10, top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255,255,255,0)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <ProgressSpinner style={{ width: '57.5px', height: '57.5px' }} strokeWidth="5" fill="var(--surface-ground)" animationDuration=".5s" />
                        </div>
                    )}
                    <div style={{ opacity: loading ? 0.2 : 1, pointerEvents: loading ? 'none' : 'auto', transition: 'opacity 0.3s ease' }}>
                        <FullCalendar
                            plugins={plugins}
                            initialView={initialView}
                            // moreLinkContent={(arg) => `Ver todos (${arg.num + 1})`} // En caso de querer vista multiMonthYear
                            // moreLinkHint={(arg) => `Mostrar ${arg + 1} monitoreos`} // tooltip vista multiMonth
                            locales={[esLocale]}
                            locale="es"
                            headerToolbar={{
                                left: 'rangoManual',
                                center: 'title',
                                right: 'today prev,next',
                            }}
                            customButtons={{
                                rangoManual: {
                                    text: 'Rango Manual',
                                    click: () => setDialogSeleccionManual(true)
                                }
                            }}
                            selectable={!loading}
                            select={handleDateSelect}
                            events={registers}
                            datesSet={handleDatesSet}
                            ref={calendarRef}
                            eventClick={mostrarMatriz}
                            {...(plugins.some(p => p?.name === '@fullcalendar/multimonth') && { multiMonthMaxColumns: 1 })}
                            eventDidMount={(info) => {
                                const start = info.event.start;
                                const endOriginal = info.event.end;
                                // Clonar la fecha para no modificar el objeto original
                                const end = endOriginal ? new Date(endOriginal) : null;
                                if (end) end.setDate(end.getDate() - 1); // Restar 1 día
                                const tooltipText = `Inicio: ${formatearFechaUTC(start)}\nFin: ${formatearFechaUTC(end)}`;
                                info.el.classList.add('tooltip-calendario');
                                info.el.setAttribute('data-pr-tooltip', tooltipText);
                                tooltipRef.current?.updateTargetEvents();
                            }}
                            selectAllow={(selectInfo) => {
                                const today = new Date();
                                today.setHours(0, 0, 0, 0);
                                const start = new Date(selectInfo.start);
                                const end = new Date(selectInfo.end);
                                start.setHours(0, 0, 0, 0);
                                end.setHours(0, 0, 0, 0);
                                end.setDate(end.getDate() - 1);
                                return start <= today && end <= today;
                            }}
                        />
                    </div>
                </div>
            }

            {dialogMonitoreo &&
                <TablaRiesgos matriz={matriz} permss={permss} funcionalidades={funcionalidades} generic={generic} toast={toast} justificaciones={justificaciones} procedimientosControl={procedimientosControl} nivelesRiesgo={nivelesRiesgo} nivelesAlerta={nivelesAlerta}
                    regresar={() => { setDialogMonitoreo(false); const startStr = rangoVista.start; const endStr = rangoVista.end; handleDatesSet({ startStr, endStr }, true); }} />}

            <Dialog header="Seleccionar rango de fechas" visible={dialogSeleccionManual} style={{ width: '40vw', maxWidth: '600px' }} modal onHide={() => setDialogSeleccionManual(false)} className="dialog-personalizado" >
                <div className="flex flex-column gap-4 p-2">
                    <div className="flex justify-content-between gap-3 w-full items-center">
                        <Calendar locale="es" value={rangoManual?.[0] || null} dateFormat="yy-mm-dd" showIcon placeholder="Fecha de inicio" className="w-full" style={{ maxWidth: '35%' }} minDate={minDate} maxDate={maxDate} readOnlyInput
                            onChange={(e) => {
                                const nuevaFechaInicio = e.value;
                                const fechaFin = rangoManual?.[1];
                                const nuevaFechaFin = fechaFin && nuevaFechaInicio && nuevaFechaInicio > fechaFin ? null : fechaFin;
                                setRangoManual([nuevaFechaInicio, nuevaFechaFin]);
                            }}
                        />
                        <Calendar locale="es" value={rangoManual?.[1] || null} dateFormat="yy-mm-dd" showIcon placeholder="Fecha de fin" className="w-full" style={{ maxWidth: '35%' }} minDate={rangoManual?.[0] || minDate} maxDate={maxDate} readOnlyInput onChange={(e) => setRangoManual([rangoManual?.[0] || null, e.value])} />
                        <Button label="Aceptar" disabled={!(rangoManual?.[0] && rangoManual?.[1])} className="w-full" style={{ maxWidth: '20%', whiteSpace: 'nowrap' }}
                            onClick={() => {
                                onAceptarRango();
                                setDialogSeleccionManual(false);
                            }}
                        />
                    </div>
                </div>
            </Dialog>

            <Dialog visible={dialogMatriz}
                header={
                    <span>
                        <i className="pi pi-calendar mr-2 text-primary"></i>
                        {getValues('id') == null ? `Nuevo monitoreo — ${mes}` : `Editar monitoreo — ${mes}`}
                    </span>
                }
                modal className="p-fluid dialog-personalizado"
                onHide={() => { setDialogMatriz(false); setMatrizSeleccionada(null); setValue('matriz_origen_id', null); }}
                style={{ width: '850px' }}
            >
                <form onSubmit={handleSubmit(onSubmit)} className="flex flex-column gap-4 mt-2">

                    <div className="surface-card p-4 shadow-2 border-round">
                        <div className="text-xl font-medium text-900 mb-3 flex align-items-center">
                            <i className="pi pi-calendar-plus text-primary mr-2 text-2xl"></i>
                            Configuración Principal
                        </div>
                        <Divider className="mt-0 mb-4" />
                        {/* Resumen visual del rango seleccionado en el calendario (solo lectura) */}
                        <div className="flex align-items-center gap-3 mb-4 p-3 bg-blue-50 border-round border-1 border-blue-200">
                            <i className="pi pi-calendar text-blue-600 text-xl"></i>
                            <div className="flex flex-column">
                                <span className="text-xs text-500 font-semibold uppercase mb-1">Rango de fechas del calendario</span>
                                <span className="text-900 font-bold">
                                    Desde {rangoFecha.inicio} &nbsp;hasta&nbsp; {rangoFecha.fin}
                                </span>
                            </div>
                            <span className="ml-auto text-sm text-blue-700 font-medium">{mes}</span>
                        </div>

                        <div className="formgrid grid">
                            {inText('codigo', { icon: 'pi pi-qrcode' }, 4)}
                            {inText('nombre', { icon: 'pi pi-pencil' }, 8)}
                            {inText('detalle', { icon: 'pi pi-align-left' }, 12)}
                        </div>
                    </div>

                    {getValues('id') == null && (
                        <div className="surface-card p-4 shadow-2 border-round bg-blue-50 border-1 border-blue-200">
                            <div className="flex flex-column md:flex-row align-items-center justify-content-between gap-3">
                                <div>
                                    <span className="text-xl font-bold text-blue-900 mb-1 flex align-items-center">
                                        <i className="pi pi-database mr-2"></i> Migración de Historial (Opcional)
                                    </span>
                                    <span className="text-sm text-blue-700 block">
                                        Hereda procedimientos, justificaciones y comentarios de un monitoreo previo en este mismo rango de fechas.
                                    </span>
                                </div>
                                <Button
                                    type="button"
                                    label="Buscar Matrices"
                                    icon="pi pi-search"
                                    className="p-button-primary w-auto"
                                    onClick={buscarMatricesOrigen}
                                />
                            </div>

                            {matrizSeleccionada && (
                                <div className="mt-4 bg-white p-3 border-round border-1 border-green-300 flex align-items-center justify-content-between shadow-1 fadein animation-duration-300">
                                    <div className="flex align-items-center">
                                        <i className="pi pi-check-circle text-green-500 text-3xl mr-3"></i>
                                        <div>
                                            <span className="block text-sm text-500 font-medium mb-1">Matriz de origen vinculada</span>
                                            <span className="block text-900 font-bold text-lg">
                                                {matrizSeleccionada.nombre}{' '}<span className="text-primary ml-1">({matrizSeleccionada.codigo})</span>
                                            </span>
                                        </div>
                                    </div>
                                    <Button type="button" icon="pi pi-trash" className="p-button-rounded p-button-danger p-button-text" tooltip="Quitar matriz" tooltipOptions={{ position: 'top' }}
                                        onClick={() => { setValue('matriz_origen_id', null); setMatrizSeleccionada(null); }} />
                                </div>
                            )}
                        </div>
                    )}

                    <div className="surface-card p-4 shadow-2 border-round">
                        <div className="flex flex-column md:flex-row align-items-center justify-content-between mb-2">
                            <div>
                                <div className="text-xl font-medium text-900">Modificar apetitos y tolerancias (Opcional)</div>
                                <div className="text-sm text-500">Configuración de niveles de apetito y tolerancia.</div>
                            </div>
                            <div className="flex align-items-center mt-3 md:mt-0 p-2 bg-gray-50 border-round">
                                <label htmlFor="editar_apetitos" className="mr-3 font-bold text-700 cursor-pointer">Modificar parámetros</label>
                                <InputSwitch inputId="editar_apetitos" checked={editarApetitos} onChange={(e) => setEditarApetitos(e.value)} />
                            </div>
                        </div>

                        {editarApetitos && (
                            <>
                                <Divider className="mb-4" />
                                <div className="formgrid grid fadeindown animation-duration-300">
                                    {inNumber('apetito_inherente', 0, false, { icon: 'pi pi-chart-line', tooltip: 'Apetito inherente', min: 0 }, 3)}
                                    {inNumber('tolerancia_inherente', 0, false, { icon: 'pi pi-sliders-h', tooltip: 'Tolerancia inherente', min: 0 }, 3)}
                                    {inNumber('apetito_residual', 0, false, { icon: 'pi pi-chart-line', tooltip: 'Apetito residual', min: 0 }, 3)}
                                    {inNumber('tolerancia_residual', 0, false, { icon: 'pi pi-sliders-h', tooltip: 'Tolerancia residual', min: 0 }, 3)}
                                </div>
                            </>
                        )}
                    </div>

                    <div className="flex justify-content-end mt-2">
                        {generic.buttonsForms(setDialogMatriz, guardando)}
                    </div>
                </form>
            </Dialog>
            <Dialog visible={dialogMigracion} header="Seleccionar Matriz de Origen" className="dialog-personalizado" modal style={{ width: '1200px' }} onHide={() => setDialogMigracion(false)}>
                <div className="surface-0 p-3 mb-3 border-round shadow-1">
                    <p className="m-0 text-700">
                        <i className="pi pi-info-circle mr-2 text-primary"></i>
                        Haga clic en la flecha <i className="pi pi-chevron-right text-sm"></i> de la izquierda para ver los perfiles analizados.
                        Seleccione "Elegir para migrar" en la matriz deseada.
                    </p>
                </div>
                <TablaDinamica modelo={MatricesCandidatasModel} estadoTabla={tablaEstadoMatrices} datos={tablaEstadoMatrices.data}
                    totalRegistros={tablaEstadoMatrices.totalRecords} dataKey="id" cuerpoTemplates={cuerpoTemplates}
                    expandedRows={expandedRows} onRowToggle={(e) => setExpandedRows(e.data)} rowExpansionTemplate={rowExpansionTemplate}
                    rowClassName={(rowData) => ({ 'bg-blue-50': expandedRows && expandedRows[rowData.id] })}
                >
                    <Column expander style={{ width: '4rem', backgroundColor: '#f8fafc', borderRight: '1px solid #e2e8f0' }} frozen alignFrozen="left" />
                </TablaDinamica>
            </Dialog>
        </>
    )
}
